import React from 'react'
import styles from '~/styles/molecules/navigation/navigation.module.scss'

import { ClickProps } from '~/common/define/props'
import { ButtonSize } from '~/components/atoms/button/ButtonBase'
import ModalActionButton from '~/components/atoms/button/ModalActionButton'

interface Props extends ClickProps {
  text: string
}

const NavigationMenuButton = ({onClick, text}: Props) => {
  return (
    <div className={styles.menu__button}>
      <ModalActionButton onClick={onClick} size={ButtonSize.SMALL}>
        {text}
      </ModalActionButton>
    </div>
  )
}

export default NavigationMenuButton